import {
    Drawer,
    Grid2,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { TicketStatusEnum } from "../../../_common/enum/ticketStatus.enum";
import { TicketTypeEnum } from "../../../_common/enum/ticketType.enum";
import EnumSelect from "../../../_components/autocomplete/enum.select";
import { StandardButton } from "../../../_components/button/primary.button";
import { toastr } from "../../../_components/toastr/toastr";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { ticketService } from "../../../_services/ticket.service";
import { TicketAffidavit } from "../_componentsTicketType/ticket-affidavit";
import { TicketDesktopTrace } from "../_componentsTicketType/ticket-desktopTrace";
import { TicketFieldAgentEnquiries } from "../_componentsTicketType/ticket-fieldAgentEnquiries";
import { TicketFullTraceEnquiries } from "../_componentsTicketType/ticket-fullTraceEnquiries";
import { TicketGeneralEnquiries } from "../_componentsTicketType/ticket-generalEnquiries";
import { TicketStatusReport } from "../_componentsTicketType/ticket-statusReport";
import { TicketOccupancyCheck } from "../_componentsTicketType/ticket-occupancyCheck";
import { TicketServe } from "../_componentsTicketType/ticket-serve";
import { TicketSurveillance } from "../_componentsTicketType/ticket-surveillance";
import { DataTypeEnum } from "../../../_common/enum/dataType.enum";
import { TicketResultEnum } from "../../../_common/enum/ticketResult.enum";
import { AgentsWithCaseDistanceMultipleAutoComplete } from "../../../_components/autocomplete/agentsWithCaseDistance.multiple.autocomplete";
import { accountService } from "../../../_services/accounts.service";
import { DataTypeAutoComplete } from "../../../_components/autocomplete/dataType.autocomplete";
import { DrawerHeader } from "../../../_components/drawer/header.drawer";
import { TicketClientPaymentTerms } from "./ticket-clientPaymentTerms";

export function TicketCreateDrawer(params: { onSave(): void, onClose(): void, setPaymentDate: (date?: string) => void }) {

    const resetData = () => ({});
    const { caseId, ticketType } = useParams<{ caseId: string, ticketType?: string }>();
    const [data, setData] = useState<any>(resetData);
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);

    }, []);

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        //need this cuz i dont know the ticket type on create and which service i need to send the submit to
        var _ticketType = getTicketTypeName(data.ticketTypeId)

        //Only here for now for testing, will remove when we proper ste this up to come from Xero
        const twoWeeksFromNow = new Date();
        twoWeeksFromNow.setDate(twoWeeksFromNow.getDate() + 14);

        const _data = {
            ...data,
            caseId: caseId,
            //Only here for now for testing, will remove when we proper ste this up to come from Xero
            paymentDate: twoWeeksFromNow,
            ...({ ticketStatusId: TicketStatusEnum.Open }),
        };

        if (_data.ticketAgents) {
            _data.ticketAgents.forEach((a: { id: any; userId: any; eventId: any; }) => {
                a.userId = a.id;
                a.eventId = _data.id;
                a.id = 0;
            });
        }

        return ticketService
            .submit(_data, _ticketType)
            .then(
                () => {
                    toastr.success("Saved successfully");
                    resetData();
                    params.onSave();
                }, handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }



    function getTicketTypeName(ticketTypeId: any): string {
        const entry = Object.entries(TicketTypeEnum).find(
            ([key, value]) => value === ticketTypeId
        );

        //Filter out the reverse mapping (numeric keys) that TypeScript creates
        if (entry && typeof entry[0] === "string" && isNaN(Number(entry[0]))) {
            return entry[0];
        }

        return "";
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    return (

        <>

            <Drawer
                anchor={"right"}
                variant="persistent"
                open={isOpen}
                ModalProps={{
                    keepMounted: true
                }}>

                <DrawerHeader name={"Create Ticket"} onClose={params.onClose} />

                <ValidatorForm
                    onSubmit={submit}
                    noValidate>

                    <Grid2 container spacing={1} sx={{ "padding": "8px" }}>

                        <TicketClientPaymentTerms caseId={caseId} />

                        <Grid2 size={{ xs: 12 }}>
                            <EnumSelect
                                key="ticketTypeId"
                                enumObject={TicketTypeEnum}
                                label="Select Ticket Type"
                                name="ticketTypeId"
                                value={data.ticketTypeId}
                                onChange={handleChange}
                                required
                                fullWidth
                            />
                        </Grid2>

                        <Grid2 size={{ xs: 12 }}>
                            <Grid2 size={{ xs: 12 }}>
                                <DataTypeAutoComplete
                                    key="ticketActionListId"
                                    dataType={DataTypeEnum.TicketActionLists}
                                    label="Select Ticket Action List"
                                    hasParent={true}
                                    parentId={data.ticketTypeId}
                                    value={data.ticketActionListId}
                                    name={"ticketActionListId"}
                                    onChange={handleChange}
                                    required={true}

                                />
                            </Grid2>
                        </Grid2>

                        <Grid2 size={{ xs: 12 }}>
                            <DataTypeAutoComplete
                                parentId={caseId ?? data.caseId}
                                key="ticketStatusId"
                                dataType={DataTypeEnum.TicketStatuses}
                                label="Select Ticket Status"
                                hasParent={true}
                                value={1} //Set to open on Create
                                name={"ticketStatusId"}
                                onChange={handleChange}
                                required={true}
                                disabled={true}

                            />
                        </Grid2>



                        <Grid2 size={{ xs: 12 }}>
                            <DataTypeAutoComplete
                                key="caseSubjectId"
                                dataType={DataTypeEnum.CaseSubjects}
                                label="Select Subject"
                                hasParent={true}
                                parentId={caseId}
                                value={data.caseSubjectId}
                                name={"caseSubjectId"}
                                onChange={handleChange}
                                required={true}
                            />
                        </Grid2>


                        {data.caseSubjectId > 0 &&
                            <Grid2 size={{ xs: 12 }}>
                                <AgentsWithCaseDistanceMultipleAutoComplete
                                    required={false}
                                    name={"ticketAgents"}
                                    hasParent
                                    parentId={data.caseSubjectId}
                                    items={data.ticketAgents}
                                    onChange={handleChange}
                                    disabled={accountService.isAgent}
                                />
                            </Grid2>
                        }

                        {/*Ticket Subject Data*/}
                        { /* {(id != null && data.ticketTypeId != TicketTypeEnum.Affidavit) && <TicketSubjectData subjectData={data.caseSubject} ticketType={data.ticketTypeId} />}*/}

                        {/*Ticket Type specific fields*/}
                        {data.ticketTypeId === TicketTypeEnum.Serve && <TicketServe data={data} setData={setData} handleChange={handleChange} />}
                        {data.ticketTypeId === TicketTypeEnum.FullTraceEnquiries && <TicketFullTraceEnquiries data={data} setData={setData} handleChange={handleChange} />}
                        {data.ticketTypeId === TicketTypeEnum.DesktopTrace && <TicketDesktopTrace data={data} setData={setData} handleChange={handleChange} />}
                        {data.ticketTypeId === TicketTypeEnum.FieldAgentEnquiries && <TicketFieldAgentEnquiries data={data} setData={setData} handleChange={handleChange} />}
                        {data.ticketTypeId === TicketTypeEnum.StatusReport && <TicketStatusReport data={data} setData={setData} handleChange={handleChange} />}
                        {data.ticketTypeId === TicketTypeEnum.OccupancyCheck && <TicketOccupancyCheck data={data} setData={setData} handleChange={handleChange} />}
                        {data.ticketTypeId === TicketTypeEnum.Surveillance && <TicketSurveillance data={data} setData={setData} handleChange={handleChange} />}
                        {data.ticketTypeId === TicketTypeEnum.Affidavit && <TicketAffidavit data={data} setData={setData} handleChange={handleChange} />}
                        {data.ticketTypeId === TicketTypeEnum.GeneralEnquiries && <TicketGeneralEnquiries data={data} setData={setData} handleChange={handleChange} />}

                        <Grid2 size={{ xs: 12 }}>
                            <EnumSelect
                                key="ticketResultId"
                                enumObject={TicketResultEnum}
                                label="Select Result"
                                name="ticketResultId"
                                value={data.ticketResultId}
                                onChange={handleChange}
                                fullWidth
                            />
                        </Grid2>

                        {!accountService.isClient &&
                            <Grid2 size={{ xs: 12 }}>
                                <Grid2 container spacing={1}>
                                    <Grid2 size={{ xs: 6 }}>
                                        <StandardButton
                                            saving={saving}
                                            loading={isLoading}
                                            icon="save"
                                            type="submit">
                                            Save
                                        </StandardButton>
                                    </Grid2>


                                    <Grid2 size={{ xs: 6 }}>
                                        <StandardButton
                                            saving={saving}
                                            loading={isLoading}
                                            icon="block"
                                            variant="error"
                                            onClick={() => { navigate(-1) }}>
                                            Cancel
                                        </StandardButton>
                                    </Grid2>

                                </Grid2>
                            </Grid2>
                        }
                    </Grid2>

                </ValidatorForm>
            </Drawer>

        </>
    );
};